import React from "react";

import enTranslations from "@shopify/polaris/locales/en.json";
import { Provider } from "@shopify/app-bridge-react";
import { AppProvider, Page, Layout } from "@shopify/polaris";

import CarrierServices from "./CarrierServices";
import BatchUpdates from "./BatchUpdates";

export default function SettingsPage(props) {

  const { apiKey, host } = props;
  const config = { apiKey, host };

  return (
    <AppProvider i18n={enTranslations}>
      <Provider config={config}>
        <Page narrowWidth singleColumn title="Settings">
          <Layout>
            <Layout.Section>
              <BatchUpdates />
            </Layout.Section>
            <Layout.Section>
              <CarrierServices />
            </Layout.Section>
          </Layout>
        </Page>
      </Provider>
    </AppProvider>
  );
}